const urlName = '/usercenter/v2/t-b/userIdentityX'

export default (API) => ({
	// 获取用户身份
	findMyIdentity() {
		return API({ url: `${urlName}/findMyIdentity` })
	},
})
